export interface RoundStats {
  elapsedSeconds: number;
  detected: number;
  closeEscapes: number;
  bestCombo: number;
  defeated: number;
}

export function calculateStars(level: number, stats: RoundStats): number {
  const targetTime = 70 + level * 12;
  const efficient = stats.elapsedSeconds <= targetTime && stats.detected <= Math.max(3, level);
  const excellent = stats.elapsedSeconds <= targetTime * 0.72
    && stats.detected <= Math.max(1, Math.floor(level / 2))
    && (stats.closeEscapes > 0 || stats.bestCombo >= 3);
  return excellent ? 3 : efficient ? 2 : 1;
}

export function calculateScore(level: number, stats: RoundStats): number {
  const base = stats.defeated * 100 + level * 250;
  const speed = Math.max(0, Math.round((180 + level * 15 - stats.elapsedSeconds) * 8));
  const skill = stats.closeEscapes * 75 + stats.bestCombo * 120;
  const detectionPenalty = stats.detected * 25;
  return Math.max(0, base + speed + skill - detectionPenalty);
}

export function isLevelComplete(defeated: number, totalMonsters: number): boolean {
  return totalMonsters > 0 && defeated === totalMonsters;
}
